import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";
import { redenVan, mapVan } from "@/lib/vaultorde";

/** Vondst Frank 27 oktober 2026: het VOLLEDIGE overzicht van wat niet is ingelezen, op een vaste plek
 *  onder Kennis. De Postbus meldt alleen nog wat er nieuw bij kwam (`vaultorde.wat_te_melden`); wie het
 *  hele overzicht wil, opent het hier. Pas opgehaald bij het openklappen, want het meet de hele vault. */
export default function NietIngelezenPaneel() {
  const { t } = useTaal();
  const [stand, setStand] = useState(null);
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState("");

  const [open, setOpen] = useState(false);

  const haal = async () => {
    if (stand || bezig) return;
    setBezig(true);
    setFout("");
    try {
      const r = await axios.get(`${API}/knowledge/not-read-in`);
      setStand(r.data || null);
    } catch (err) {
      setFout(err?.response?.data?.detail || t("Het overzicht kon niet worden opgehaald."));
    } finally {
      setBezig(false);
    }
  };

  return (
    <section className="rounded-md border px-2 py-1 text-xs" data-testid="niet-ingelezen-paneel">
      <button type="button" className="w-full text-left text-muted-foreground tap-target py-1"
        aria-expanded={open} data-testid="niet-ingelezen-knop"
        onClick={() => { const nu = !open; setOpen(nu); if (nu) haal(); }}>
        {t("Niet ingelezen")}
      </button>
      {open && (<>
      {bezig && <Loader2 className="h-4 w-4 animate-spin text-muted-foreground my-2" />}
      {fout && <p className="text-destructive py-1">{fout}</p>}
      {stand && !stand.bereikbaar && (
        <p className="py-1 text-muted-foreground">{t("De vault is nu niet bereikbaar, dus er valt niets te meten.")}</p>
      )}
      {stand && stand.bereikbaar && (
        <div className="space-y-2 py-1" data-testid="niet-ingelezen-overzicht">
          <p>{t("Niet ingelezen: {n} bestanden", { n: stand.totaal })}</p>
          {stand.overgeslagen?.aantal > 0 && (
            <p className="text-muted-foreground">
              {t("Overgeslagen mappen, niet meegeteld: {aantal} bestanden in {mappen}",
                { aantal: stand.overgeslagen.aantal, mappen: (stand.overgeslagen.mappen || []).join(", ") })}
            </p>
          )}
          <ul className="space-y-1">
            {(stand.groepen || []).map((g) => {
              const [sleutel, waarden] = redenVan(g.reden);
              const [mapSleutel, mapWaarden] = mapVan(g.map);
              return (
                <li key={`${g.map}|${g.reden}`}>
                  {t("{map}: {aantal} keer {reden}", { map: t(mapSleutel, mapWaarden), aantal: g.aantal, reden: t(sleutel, waarden) })}
                  <span className="block text-muted-foreground break-all">{(g.paden || []).join(", ")}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      </>)}
    </section>
  );
}
